export default __webpack_public_path__ + "static/media/withdrawIconDark.d5295025.svg";